/*=========================================================================================
  File Name: state.js
  Description: Phone Service State
  ----------------------------------------------------------------------------------------
  Item Name: Phone Service Module
  Author: Tan Tran
==========================================================================================*/

export default {
  selectedRestaurantId : null,
  restaurants : [],
  categories : [],
  products : [],
  taxes : [],
  orders : [],
  currentWaitingTime : 20,
  orderManagerState : {
    capacity : 1,
    currentWaitingTime : 5,
    minWaitingTime : 5,
    maxWaitingTime : 10,
    cannotOrderNow : false,
    increaseTimeStep : 2,
    pendingOrdersIncreaseStep : 2,
    initTimeOfOrder : 2,
    offTime : null,
    isEnabled : false
  },
  resetState : false
} 